import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgError(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <circle cx={16} cy={16} r={16} fill="#CC0029" />
      <path
        fill="white"
        d="M16 18.1998L21.9001 24.0999L24.1 21.9L18.1999 15.9999L24.1 10.0998L21.9001 7.8999L16 13.8L10.0999 7.8999L7.90003 10.0998L13.8001 15.9999L7.90002 21.9L10.0999 24.0999L16 18.1998Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgError);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
